import { useState } from 'react';
import { apiClient } from '../utils/apiClient';
import { API_CONFIG } from '../config/apiConfig';

interface ValidateSerialResponse {
  success: boolean;
  data?: any[];
  error?: string;
}

export const useValidateSerialNumber = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validateSerial = async (whid: string, serialNumber: string) => {
    if (!whid || !serialNumber) {
      throw new Error('WHID and Serial Number are required');
    }

    setIsLoading(true);
    setError(null);

    try {
      const { data } = await apiClient.get<ValidateSerialResponse>(
        API_CONFIG.ENDPOINTS.VALIDATE_SERIAL_NUMBER,
        {
          params: {
            p_whid: whid,
            p_serial_number: serialNumber,
          },
        }
      );

      if (data.success && data.data) {
        return data.data;
      } else {
        throw new Error(data.error || 'Validation failed');
      }
    } catch (err: any) {
      const errorMessage = err.response?.data?.error || err.message;
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    validateSerial,
    isLoading,
    error,
  };
};